import React from 'react'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import IconButton from '@material-ui/core/IconButton'
import Button from '@material-ui/core/Button';
import HomeIcon from '@material-ui/icons/Home';
import { Link } from 'react-router-dom';
import { withStyles } from '@material-ui/core';

const style = {
  root: {
    marginBottom: '2em',
  },
}

const NavBar = ({ customer, classes }) => {
  return (
    <div>
      <AppBar position="static" className={classes.root}>
        <Toolbar>
          <IconButton href="/" color="inherit">
            <HomeIcon />
          </IconButton>
          <Button variant="outlined" color="inherit" component={Link} to="/">
            Quick Shop
              </Button>
        </Toolbar>
      </AppBar>
    </div>
  )
}
export default withStyles(style)(NavBar);
